import { faUsers, faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';
import { getUkrainianPlural } from 'helpers/getUkrainianPlural';
import { Checkbox } from 'components/Checkbox';
import { Tooltip } from 'components/Tooltip';
import styles from './GroupCard.scss';

export const GroupCard = ({
  group: { id, name, isClub, membersAmount },
  location,
  isSelected,
  isSelectionMode,
  toggleSelection,
  isShowLocation,
}) => {
  const navigate = useNavigate();

  const navigateToGroupPage = () => {
    navigate(`${id}`);
  };

  return (
    <button
      className={cn(styles.card, { [styles.selected]: isSelected, [styles.selectionMode]: isSelectionMode })}
      onClick={() => (isSelectionMode ? toggleSelection(id) : navigateToGroupPage())}
    >
      <div className={styles.header}>
        <h3>
          {isSelectionMode && <Checkbox className={styles.checkbox} checked={isSelected} />}
          {name}
          {isClub && <FontAwesomeIcon icon={faStar} className={styles.clubBadge} />}
          <Tooltip className={styles.tooltip} text='Клубна група' position='right' />
        </h3>
        {isShowLocation && <span className={styles.location}>{location?.name}</span>}
      </div>

      {membersAmount > 0 && (
        <div className={styles.stats}>
          <div className={styles.statItem}>
            <FontAwesomeIcon icon={faUsers} />
            <span>
              {membersAmount} {getUkrainianPlural(membersAmount, ['танцюрист', 'танцюриста', 'танцюристів'])}
            </span>
          </div>
        </div>
      )}
    </button>
  );
};
